export const LABEL_COLORS_DEFAULT = {
  background: 'accent-negative-secondary',
  color: 'accent-negative-primary'
};
export const COUNTER_MAX_LENGTH_DEFAULT = 3;
export const SIZE_BY_DEVICE_TYPE = {
  desktop: 'S',
  tablet: 'M',
  phone: 'M'
};
export const TEST_ID = 'tabs';